import React from 'react';

/**
 * FormButtons renders a row of FormButton components.
 */
const FormButtons = ({children}) => {
  return (
    <div className="sp-form-buttons row">
      {children}
      <div className="col-12"/>
    </div>
  );
};

export default FormButtons;
